import { render, staticRenderFns } from "./GrabReportForDB.vue?vue&type=template&id=21e76797"
import script from "./GrabReportForDB.vue?vue&type=script&lang=js"
export * from "./GrabReportForDB.vue?vue&type=script&lang=js"
import style0 from "./GrabReportForDB.vue?vue&type=style&index=0&id=21e76797&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports